import { render, staticRenderFns } from "./EmailMessageCard.vue?vue&type=template&id=86edaacc&"
import script from "./EmailMessageCard.vue?vue&type=script&lang=js&"
export * from "./EmailMessageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports